import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	videoThumbnailAltText: {
		id: 'video-search-result.video-thumbnail-alt-text',
		defaultMessage: 'Video thumbnail',
		description: 'Video thumbnail alt text',
	},
	videoIconLabel: {
		id: 'video-search-result.video-icon-label',
		defaultMessage: 'video icon',
		description: 'Video icon label',
	},
	videoLabel: {
		id: 'video-search-result.video-label',
		defaultMessage: 'Video',
		description: 'Video label',
	},
	dropdownMessage: {
		id: 'video-search-result.dropdown-message',
		defaultMessage:
			'{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}',
		description: 'Dropdown message for video search result',
	},
	durationInSeconds: {
		id: 'video-search-result.duration.seconds',
		defaultMessage: '{seconds} sec',
		description: 'Seconds unit display for video duration',
	},
	durationInMinutes: {
		id: 'video-search-result.duration.minutes',
		defaultMessage: '{minutes} min',
		description: 'Minutes unit display for video duration',
	},
	durationInHours: {
		id: 'video-search-result.duration.hours',
		defaultMessage: '{hours} hour {minutes} min',
		description: 'Hours unit display for video duration',
	},
});
